module.exports = __webpack_public_path__ + "static/media/contact.9eb2b3e2.jpg";